import { render, staticRenderFns } from "./ImportGenerate.vue?vue&type=template&id=425ca08d&scoped=true"
import script from "./ImportGenerate.vue?vue&type=script&lang=js"
export * from "./ImportGenerate.vue?vue&type=script&lang=js"
import style0 from "./ImportGenerate.vue?vue&type=style&index=0&id=425ca08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ca08d",
  null
  
)

export default component.exports